// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"MarcaUnidadDetalle_spinnerContainer__XJb4a"};